import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const Modal = ({ title, children, footer, onClose, busy = false }) => {
  const ref = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    ref.current?.focus();
    return () => { document.body.style.overflow = overflow; previous?.focus?.(); };
  }, []);
  return createPortal(<div className="modal modal-blur d-block seller-stock-backdrop" role="presentation">
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg seller-stock-dialog">
    <section ref={ref} tabIndex={-1} className="modal-content" role="dialog" aria-modal="true" aria-label={title}
      onKeyDown={(event) => {
        if (event.key === "Escape" && !busy) { event.stopPropagation(); onClose(); }
        if (event.key === "Tab") {
          const elements = [...ref.current.querySelectorAll('button:not(:disabled), input:not(:disabled), textarea:not(:disabled), [tabindex="0"]')].filter((element) => element.getClientRects().length);
          const first = elements[0]; const last = elements[elements.length - 1];
          if (event.shiftKey && (document.activeElement === first || document.activeElement === ref.current)) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && (document.activeElement === last || document.activeElement === ref.current)) { event.preventDefault(); first?.focus(); }
        }
      }}>
      <header className="modal-header"><h5 className="modal-title">{title}</h5><button type="button" className="btn-close" aria-label="Tutup" onClick={onClose} disabled={busy} /></header>
      <div className="modal-body">{children}</div>
      <footer className="modal-footer">{footer}</footer>
    </section>
    </div>
  </div>, document.querySelector(".akas-app-shell") || document.body);
};
export default Modal;
